// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fw-a";
export var fulfillmentFormRail = "_fw-9";
export var headerTitleRow = "_fw-c";
export var orderDetailsWrapper = "_fw-7";
export var orderLinkTrigger = "_fw-2";
export var paymentInformationGrid = "_fw-h";
export var paymentSummaryColumn = "_fw-i";
export var shipmentContainer = "_fw-b";
export var shipmentDetailsMainPane = "_fw-8";
export var shipmentNavigationCard = "_fw-5";
export var shipmentNavigationRail = "_fw-3";
export var shipmentNavigationRailHeader = "_fw-4";
export var shipmentSummaryFact = "_fw-e";
export var shipmentSummaryGrid = "_fw-d";
export var shipmentSummaryMetadataRow = "_fw-f";
export var shipmentSummaryTags = "_fw-g";
export var shipmentWorkspace = "_fw-0";
export var shipmentWorkspaceContent = "_fw-6";
export var shipmentWorkspaceHeader = "_fw-1";